// In-memory only: preserve print inputs when Shopify replaces the variant form.
(() => {
if (window.paiPersonalizationLoaded) return;
window.paiPersonalizationLoaded = true;
const paiSavedPrint = new Map();
const paiInitializedPrint = new WeakSet();
function paiUpdatePrintFields(scope) {
  const choice = scope.querySelector('[data-pai-print-choice]');
  const fields = scope.querySelector('[data-pai-custom-fields]');
  if (!fields) return;
  const toggle = scope.querySelector('[data-pai-print-toggle]');
  const active = choice ? choice.value === 'Oma painatus' : !!toggle?.checked;
  fields.hidden = !active;
  const name = scope.querySelector('[data-pai-print-name]');
  const number = scope.querySelector('[data-pai-print-number]');
  for (const field of [name, number].filter(Boolean)) {
    field.disabled = !active;
    field.setCustomValidity('');
  }
  if (choice && active && !name?.value.trim() && !number?.value.trim()) {
    (name || number).setCustomValidity('Lisää nimi tai numero omaa painatusta varten.');
  }
}
function paiInitPrintFields() {
  document.querySelectorAll('[data-pai-personalization]').forEach(scope => {
    if (!paiInitializedPrint.has(scope)) {
      const values = paiSavedPrint.get(scope.dataset.paiProductId);
      if (values && scope.querySelector('[data-pai-print-toggle]')) scope.querySelector('[data-pai-print-toggle]').checked = !!values.paiEnabled;
      if (values) scope.querySelectorAll('input[name],select[name]').forEach(field => {
        if (Object.hasOwn(values, field.name)) field.value = values[field.name];
      });
      paiInitializedPrint.add(scope);
    }
    paiUpdatePrintFields(scope);
  });
}
function paiRememberPrint(scope) {
  const values = { paiEnabled: !!scope.querySelector('[data-pai-print-toggle]')?.checked };
  scope.querySelectorAll('input[name],select[name]').forEach(field => { values[field.name] = field.value; });
  paiSavedPrint.set(scope.dataset.paiProductId, values);
}
document.addEventListener('input', (event) => {
  const scope = event.target.closest('[data-pai-personalization]');
  if (scope) { paiUpdatePrintFields(scope); paiRememberPrint(scope); }
});
document.addEventListener('change', (event) => {
  const scope = event.target.closest('[data-pai-personalization]');
  if (scope) { paiUpdatePrintFields(scope); paiRememberPrint(scope); }
});
document.addEventListener('submit', (event) => {
  const scope = event.target.querySelector?.('[data-pai-personalization]');
  if (scope) { paiUpdatePrintFields(scope); paiRememberPrint(scope); }
}, true);
new MutationObserver(paiInitPrintFields).observe(document.documentElement, { childList: true, subtree: true });
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paiInitPrintFields);
else paiInitPrintFields();
})();
